import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-panel-wrapper',
  templateUrl: './panel-wrapper.component.html',
  styleUrls: ['./panel-wrapper.component.scss']
})
export class PanelWrapperComponent extends FieldWrapper {
  getPanelTitle(): string {
    // 1. Label aus templateOptions
    if (this.to && this.to.label) {
      return this.to.label;
    }
    // 2. Fallback: Index, falls vorhanden (z.B. bei Arrays)
    if (typeof this.field?.key === 'number') {
      return 'Eintrag ' + (this.field.key + 1);
    }
    // 3. Sonst: Key oder leer
    return this.field?.key?.toString() || '';
  }
}
